import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { forgottenPasswordRequest } from '../ducks';
import { ForgottenPasswordForm } from '../components';

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      forgottenPasswordRequest,
    },
    dispatch
  ),
});

@connect(undefined, mapDispatchToProps)
export default class ForgottenPasswordContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { actions } = this.props;

    return <ForgottenPasswordForm onSubmit={actions.forgottenPasswordRequest} />;
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/containers/ForgottenPasswordContainer.js